import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import Pagination from '../../../container/MUI/Pagination';
import Button from '@mui/material/Button';
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SuppliersForm from './SuppliersForm';
import { Edit, CloudDownloadRounded } from '@mui/icons-material';
import { IconButton, Grid, Box } from '@mui/material';
import SupplierSingle from './SupplierSingle';
import SearchBar from '../../common/SearchBar';
import SuppliersAdvanceForm from './SuppliersAdvanceForm';
import Currency from '../../common/Currency';

class SuppliersList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        openForm: false,
        openCredit: false,
        openUpdate: false,
        openDetails: false,
        selected: {},
        searchValue: "",
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        if(isEmpty(this.props.ADVANCES)){
            this.props.fetchSupplierAdvances()
        }
        
    }

    handleClose = () => {
		this.setState({ 
            openDetails: false,
            openForm: false,
            openCredit: false,
            openUpdate: false,
            selected: {},
        });
    };    

    // Reste à payer par fournisseur : même calcul que la fiche fournisseur (somme des spending_rest_to_pay)
    getRestToPayBySupplier = () => {
        const { SPENDINGS } = this.props;
        let restBySupplier = {}
        Object.values(SPENDINGS || {}).forEach(spending => {
            const supplierID = spending.spending_supplier
            const rest = Number(spending.spending_rest_to_pay)
            if (!supplierID || !Number.isFinite(rest)) return
            restBySupplier[supplierID] = (restBySupplier[supplierID] || 0) + rest
        })
        return restBySupplier
    }

    getSuppliersList = () => {
        const { rowsPerPage, page, searchValue } = this.state;
        const { SUPPLIERS, SPENDINGS } = this.props;

        if (!isEmpty(SUPPLIERS)){
            let list = Object.values(SUPPLIERS)
            if( !isEmpty(searchValue) ){
                list = list.filter( supplier =>
                    [supplier.supplier_name, supplier.supplier_code, supplier.supplier_category, supplier.supplier_advance_category].some(
                        field => typeof field === 'string' && field.toLowerCase().includes(searchValue)
                    )
                );
            }
            // Dépenses pas encore chargées : ne pas afficher un faux reste à payer à 0
            const spendingsLoaded = !isEmpty(SPENDINGS)
            const restBySupplier = this.getRestToPayBySupplier()
            return list.map(item =>  {
            // return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item =>  (
                const openDetails = () => this.setState({ openDetails: true, selected: item})
                const restToPay = Math.round(restBySupplier[item.supplier_id] || 0)
                const advance = Math.round(Number(item.supplier_account) || 0)
                // Solde = reste à payer - acompte versé (négatif : l'acompte dépasse ce qui reste dû)
                const balance = restToPay - advance
                return (
                <TableRow
                    hover
                    className="clickable"
                    key={item.supplier_id}
                >
                    <TableCell onClick={openDetails}>{item.supplier_category}</TableCell>
                    <TableCell onClick={openDetails}>{item.supplier_advance_category}</TableCell>
                    <TableCell onClick={openDetails}>{item.supplier_name}</TableCell>
                    <TableCell align="right" onClick={openDetails}>
                        {spendingsLoaded ? <Currency value={restToPay} /> : "…"}
                    </TableCell>
                    <TableCell align="right" onClick={openDetails}>
                        <Currency value={advance} />
                    </TableCell>
                    <TableCell
                        align="right"
                        style={{ fontWeight: 'bold', color: spendingsLoaded && balance < 0 ? '#c62828' : undefined }}
                        onClick={openDetails}
                    >
                        {spendingsLoaded ? <Currency value={balance} /> : "…"}
                    </TableCell>
                    <TableCell>
                        <IconButton 
                            size="small" 
                            onClick={ () => this.setState({openUpdate: true, selected: item}) }
                        >
                            <Edit />
                        </IconButton> 
                    </TableCell>                                                     
                </TableRow>
                )
            })
        }
    }

    handleChange = (e) => {
        const { value } = e.target;

        this.setState({
            "searchValue": value.toLowerCase()
        })
    }
    render() {
        const { openDetails, openForm, rowsPerPage, page, openUpdate, selected, openCredit } = this.state;
        return (
            <div>
                {openForm &&
                    <SuppliersForm open={openForm} handleClose={this.handleClose} {...this.props} />
                }
                {openCredit &&
                    <SuppliersAdvanceForm open={openCredit} handleClose={this.handleClose} {...this.props} />
                }
                {openDetails && !isEmpty(selected) &&
                    <SupplierSingle 
                        open={openDetails} 
                        supplier={selected}
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {openUpdate && !isEmpty(selected) &&
                    <SuppliersForm 
                        update 
                        supplier={selected} 
                        open={openUpdate} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                
                <Typography variant="h6" id="tableTitle">
                    Liste des Fournisseurs
                </Typography>

                <Box style={{ display:"flex", justifyContent:"space-between", alignItems: "center"}}>
                    <SearchBar 
                        handleChange={this.handleChange} 
                        label="Rechercher par nom, code, compte ou compte d'avance"
                        searchValue={this.state.searchValue}
                    />
                    <Box style={{ display:"flex", flexDirection:"column", justifyContent:"space-between"}}>
                        <Button 
                            variant="contained" 
                            color="secondary" 
                            onClick={() => this.setState({ openForm: true})} title="Nouveau Fournisseur"
                            startIcon={<AddCircleIcon />}
                        >
                            Ajouter
                        </Button>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={() => this.setState({ openCredit: true})} title="Nouvel Accompte"
                            startIcon={<AddCircleIcon />}
                        >
                            Acompte
                        </Button>
                    </Box>
                    <IconButton color="primary" onClick={ () => this.props.handleDownload("/extract/suppliers", "MJB_fournisseurs.csv") } disabled={this.props.downloading}>
                        <CloudDownloadRounded />
                    </IconButton>
                </Box>

                
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Compte</TableCell>
                            <TableCell>Compte d'avance</TableCell>
                            <TableCell>Nom</TableCell>
                            <TableCell align="right">Reste à payer</TableCell>
                            <TableCell align="right">Acompte</TableCell>
                            <TableCell align="right">Solde</TableCell>
                            <TableCell>Modifier</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.getSuppliersList()}
                    </TableBody>
                    {/* {size(SUPPLIERS) > 10 &&
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[10, 15]}
                                    colSpan={2}
                                    count={size(SUPPLIERS)}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    onPageChange={this.handleChangePage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                    ActionsComponent={Pagination}
                                />
                            </TableRow>
                        </TableFooter>
                    } */}
                </Table> 
            </div>
        );
    }
}

export default SuppliersList;